module.exports = __webpack_public_path__ + "static/media/favorite-inactive.ada80c0c.svg";